import React, {PureComponent} from 'react';
import PropTypes from "prop-types";

import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import "../fgfStyles.css";
import config from "../config/api.json";
import axios from "axios";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconButton from "@material-ui/core/IconButton";
import InvisibleImg from "../a11y/InvisibleImg";
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import "./DpaSportsApiCard.css"
import MenuItem from "@material-ui/core/MenuItem";
import {BestFitText} from "../components/BestFitText";
import RefreshIcon from '@material-ui/icons/Refresh';
import PulsatingCircle from "../components/PulsatingCircle";
import './ReloadButton.css';



const useStyles = makeStyles((_) => ({
    dpaSportCard: {
        paddingBottom: 16,
    },
    title_h1: {
        color: '#000000',
        marginBottom: 16,
        fontWeight: 500,
        fontSize: 34,
        fontFamily: "DinforPBR",
        letterSpacing: "-0.5px",
        lineHeight: 38 / 34,
    },
    title_h2: {
        color: '#000000',
        marginBottom: 16,
        fontWeight: 500,
        fontSize: 24,
        fontFamily: "DinforPBR",
        letterSpacing: 0.0,
        lineHeight: 1.2,
    },
    title_h3: {
        color: '#000000',
        marginBottom: 8,
        fontWeight: 500,
        fontSize: 20,
        fontFamily: "DinforPBR",
        lineHeight: 26 / 20,
        letterSpacing: 0.0,
    },
    kicker: {
        color: '#666666',
        marginBottom: 8,
        fontWeight: 500,
        fontSize: 14,
        letterSpacing: 18 / 14,
        fontFamily: "DinforPBR",
    },
    date_heading: {
        color: '#666666',
        marginBottom: 3,
        marginTop: 2,
        fontWeight: 400,
        fontSize: 16,
        fontFamily: "DinforPBR",
        lineHeight: 21 / 16
    },
    creditline: {
        color: '#757575',
        marginBottom: 18,
        fontWeight: 400,
        fontSize: 12,
        fontFamily: "DinforPBR",
        lineHeight: "16px"
    },
    caption: {
        color: '#000000',
        fontWeight: 400,
        fontSize: 14,
        fontFamily: "DinforPBR",
        lineHeight: "18px"
    },
    creditline_inline: {
        color: '#757575',
        marginBottom: 18,
        fontWeight: 400,
        fontSize: 12,
        fontFamily: "DinforPBR",
        paddingTop: 8
    },
    caption_inline: {
        color: '#000000',
        fontWeight: 400,
        fontSize: 14,
        fontFamily: "DinforPBR",
        paddingTop: "1em",
        lineHeight: "18px"

    },
    teaser: {
        color: '#000000',
        fontWeight: 900,
        fontSize: 16,
        fontFamily: "DinforPBR",
        lineHeight: "21px"
    },

    list: {
        marginBottom: 6,
    },
    p: {
        color: '#000000',
        fontWeight: 400,
        fontSize: 16,
        fontFamily: "DinforPBR",
        lineHeight: 21 / 16
    },
    headerText: {
        color: '#666666',
        fontWeight: 400,
        fontSize: 16,
        fontFamily: "DinforPBR",
        lineHeight: 21 / 16,
    },
    logoImage: {
        maxHeight: 20,
        paddingLeft: 12,
        paddingRight: 12,
    },
    row: {
        display: "flex",
        paddingTop: 4,
        paddingBottom: 4
    },
    titleRow: {
        display: "flex",
        justifyContent: "space-between",
        paddingTop: 4,
        paddingBottom: 4
    },
    dividerSmall: {
        height: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
    divider: {
        height: 2,
        backgroundColor: 'rgba(217, 217, 217, 1)',
    },
    arrowButton: {
        padding: '0px',
        paddingTop: '5px',
        marginLeft: '-6px',
        marginRight: '-6px',
    },
    arrow: {
        fontSize: '24px',
        fontWeight: 500,
        color: '#0094D4',
        cursor: "pointer",
    },
    border: {
        border: '2px solid #0094D4',
        borderRadius: 6,
    },
    formControl: {
        "&, &:before, &:after": {
            border: 'none',
        },
        color: '#0094D4',
        fontWeight: 900,
        fontSize: 16,
        fontFamily: "DinforPBR",
        lineHeight: 20 / 16,
        paddingTop: 4,
    },
    linkContainer: {
        display: "flex",
        alignItems: "center", /* Zentriert die Elemente vertikal */
        gap: 4, /* Fügt etwas Abstand zwischen Icon und Text hinzu */
        textDecoration: "none", /* Entfernt die Standard-Unterstreichung des Links */
        color: "#007bff",
    },
    linkText: {
        color: '#1D89BF',
        fontWeight: 400,
        fontSize: 16,
        fontFamily: "DinforPBR",
        lineHeight: 21 / 16
    }

}));

class DpaSportsApiCard extends PureComponent {

    constructor(props) {
        super(props);
        let data = null;
        let lastModified = null;
        this.state = {
            data: null,
            lastModified: null,
            selectedMatchDay: null,
            matchDays: new MatchDays(),
            error: null,
            reloadingTimestamp: null,
        }
        this.onDataReceived = this._onDataReceived.bind(this);
        this.getViewData = this._getViewData.bind(this);
        this.headViewData = this._headViewData.bind(this);
        this.onMatchDaySelected = this._onMatchDaySelected.bind(this);
        this.reload = this._reload.bind(this);

    }

    componentDidMount() {
        this.load();
    }

    isTable() {
        const {kachel} = this.props;
        return 'uestra/dpa-sportlive-table' === kachel.type
    }


    render() {
        if (this.isTable()) {
            return this.renderTable();
        } else {
            return this.renderMatches()
        }

    }

    renderTable() {
        const {classes, kachel, full, userLang} = this.props;
        const {data, reloadingTimestamp} = this.state;
        var reloading = reloadingTimestamp != null;
        let cc = 0
        let children = [];
        let areMatchesLive = false;

        try {
            if (data === null || data[0] === null || data[0].competition === null || data[0].competition[0] === null || data[0].competition[0].season === null || data[0].competition[0].season[0] === null || data[0].competition[0].season[0].round === null || data[0].competition[0].season[0].round[0] === null) {
                return (<div></div>);
            }

            let round = data[0].competition[0].season[0].round[0];
            let showNegativePoints = false;
            for (let standing of round.standing) {
                showNegativePoints = showNegativePoints || standing.minuspoints != null;
            }

            let count = 0;
            children.push((
                <div key={cc++} className={classes.row}>
                    <div key={cc++} style={{
                        minWidth: 24 + 24 + 20,
                        maxWidth: 24 + 24 + 20
                    }}>{this.asHeader("Platz", "start")}</div>
                    <div key={cc++} style={{flexGrow: 4}}>{this.asHeader("Verein", "start")}</div>
                    <div key={cc++} style={{minWidth: 40, maxWidth: 40}}>{this.asHeader("Sp.")}</div>
                    <div key={cc++} style={{minWidth: 40, maxWidth: 40}}>{this.asHeader("Diff.")}</div>
                    <div key={cc++} style={{
                        minWidth: showNegativePoints ? 64 : 40,
                        maxWidth: showNegativePoints ? 64 : 40
                    }}>{this.asHeader("Pkt.", showNegativePoints ? "center" : "end")}</div>


                </div>));


            for (let standing of round.standing) {
                let isLive = false;
                if (standing.matches_live !== "0" /*|| standing.team.name.includes("b") */) {
                    areMatchesLive = true;
                    isLive = true;
                }
                count++;
                let dividerClassName = this.getDividerClassName(count, round);
                children.push((<Divider key={cc++} className={dividerClassName}></Divider>));

                let row = [];
                let color = isLive ? '#CC2200' : null;
                let rowColor = isLive ? {color:'#CC2200'} : {};
                let firstItemStyle = isLive ? {color:'#CC2200', minWidth: 24, maxWidth: 24} : {minWidth: 24, maxWidth: 24};
                children.push((<div key={cc++} className={classes.row} >{row}</div>));

                row.push((<div key={cc++} style={firstItemStyle}>{this.asP(standing.rank + ".", color)}</div>))
                row.push((<img key={cc++}
                               className={classes.logoImage}
                               src={this.getLogoUrl(standing.team.id)}
                               alt={"Flage " + standing.team.name}
                />));
                row.push((<div key={cc++} style={{flexGrow: 4}}>
                    <Typography variant='body1' component='div' classes={{root: this.props.classes.p}} style={rowColor}>
                        <BestFitText
                            texts={[standing.team.microname, standing.team.shortname, standing.team.name]}
                            fontStyles={'bold 16px "DinforPBR", sans-serif'}

                        />
                    </Typography>
                </div>));
                row.push((<div key={cc++} style={{
                    paddingLeft: 0,
                    minWidth: 40,
                    maxWidth: 40,
                    textAlign: "end"
                }}>{this.asP(standing.matches, color)}</div>));

                row.push((<div key={cc++} style={{
                    paddingLeft: 0,
                    minWidth: 40,
                    maxWidth: 40,
                    textAlign: "end"
                }}>{this.asP(standing.difference, color)}</div>));

                if (showNegativePoints) {
                    row.push((<div key={cc++} style={{
                        paddingLeft: 0,
                        minWidth: 64,
                        maxWidth: 64,
                        textAlign: "end"
                    }}>
                        <Typography variant='body1' component='p' classes={{root: this.props.classes.p}}  style={rowColor}>
                            <div style={{ display: "flex"}}>
                                <div style={{flexGrow: 4, textAlign: "end"}}>{standing.points}</div>
                                <div>:</div>
                                <div style={{flexGrow: 4, textAlign: "start"}}>{standing.minuspoints}</div>
                            </div>
                        </Typography>
                    </div>));
                } else {
                    row.push((<div key={cc++} style={{
                        paddingLeft: 0,
                        minWidth: 40,
                        maxWidth: 40,
                        textAlign: "end"
                    }}>{this.asP(standing.points, color)}</div>));
                }

            }
            children.push((<Divider key={cc++} className={classes.divider}></Divider>));
            children.push((<div key={cc++} style={{paddingBottom: 16}}></div>));

            children.push(this.asHeader(kachel.description, "start"));

        } catch (e) {
            console.log(e);
        }

        let title = areMatchesLive ? "LIVE-TABELLE" : "TABELLE";

        const refreshClassName = reloading ? 'spinner-active' : '';

        return (
            <div className={classes.dpaSportCard}>
                <div style={{paddingBottom: 4}}/>
                <Typography
                    variant='h3'
                    component='h3'
                    classes={{root: classes.title_h3}}
                >
                    <div className={classes.titleRow}>
                        <div>{title}</div>
                        <a
                            className={classes.linkContainer}
                            onClick={this.reload}
                        >
                            <div style={{paddingTop: 4}}>
                            <RefreshIcon className={refreshClassName} style={{fill: "#1D89BF", fontSize: 16}}/>
                            </div>
                            <Typography
                                variant='h3'
                                component='h3'
                                classes={{root: classes.linkText}}
                            >
                                aktualisieren
                            </Typography>
                        </a>

                    </div>

                </Typography>
                <div>{children}</div>

            </div>
        );
    }

    getDividerClassName(count, round) {
        const {classes} = this.props;

        for (let roundMarker of round.round_marker) {
            if (roundMarker.from === "" + count || roundMarker.to === "" + (count - 1)) {
                return classes.divider;
            }
        }
        return classes.dividerSmall;
    }

    renderMatches() {
        const {classes} = this.props;
        const {data, selectedMatchDay, reloadingTimestamp} = this.state;
        var reloading = reloadingTimestamp != null;
        if (!data) return null;

        let children = [];
        let cc = 0;

        try {
            let round = data[0].competition[0].season[0].round[0];

            let currentDate;
            let hasLiveMatches = false;
            for (let match of round.match) {
                if(match.real_live_status === "live" /*||match.home.name.includes("b")*/) {
                    hasLiveMatches = true;
                    break;
                }
            }
            for (let match of round.match) {
                if (match.matchday !== selectedMatchDay.day) continue;
                if (match.match_date !== currentDate) {
                    currentDate = match.match_date;
                    children.push((<Divider className={classes.divider}></Divider>));
                    children.push((<div style={{
                        textAlign: "center",
                        paddingTop: 2,
                        paddingBottom: 1
                    }}>
                        <Typography
                            variant='body1'
                            component='p'
                            classes={{root: classes.date_heading}}
                        >
                            {this.formatMatchDate(match.match_date)}
                        </Typography>
                    </div>))
                }
                children.push((<Divider key={cc++} className={classes.dividerSmall}></Divider>));

                let isLive =  match.real_live_status === "live"; // ||match.home.name.includes("b");

                let matchResultHome = this.getMatchResult(match, match.home.id);
                let matchResultAway = this.getMatchResult(match, match.away.id);


                let row = [];
                let rowColor = isLive ? {color:'#CC2200'} : {};
                children.push((
                    <Typography  key={cc++}
                        variant='body1'
                        component='div'
                        classes={{root: classes.p}}
                    >
                        <div className={classes.row} style={rowColor}>
                            {row}
                        </div>
                    </Typography>))
                if(isLive) {
                    row.push((<PulsatingCircle/>));
                } else if(hasLiveMatches){
                    row.push((<div style={{minWidth: 24, maxWidth: 24}}></div>));
                }
                row.push((
                    <div style={{flexGrow: 8, width: 0, textAlign: "end"}}>
                        <BestFitText
                            texts={[match.home.microname, match.home.shortname, match.home.name]}
                            fontStyles={'bold 16px "DinforPBR", sans-serif'}

                        />
                    </div>
                ));
                //"italic bold 16px \"DinforPBR\" sans-serif"
                row.push((<img
                    className={classes.logoImage}
                    src={this.getLogoUrl(match.home.id)}
                    alt={"Flage " + match.home.name}
                />));
                if (matchResultHome !== "") {
                    row.push((<div>{matchResultHome}</div>))
                }

                if (match.real_live_status !== "upcoming" && match.match_time !== "unknown") {
                    row.push((<div>{":"}</div>))
                }

                if (match.real_live_status === "none") {
                    row.push((<div>{"－"}</div>))
                }

                if (match.real_live_status === "upcoming" && match.match_time !== "unknown") {
                    row.push((<div>{this.utcTimeToBerlin(match.match_date, match.match_time)}</div>))
                }

                if (match.real_live_status === "upcoming" && match.match_time === "unknown") {
                    row.push((<div>{"-:-"}</div>))
                }

                if (matchResultAway !== "") {
                    row.push((<div>{matchResultAway}</div>))
                }
                row.push((<img
                    className={classes.logoImage}
                    src={this.getLogoUrl(match.away.id)}
                    alt={"Flage " + match.away.name}
                />));
                row.push((<div style={{flexGrow: 8, width: 0}}>
                    <BestFitText
                        texts={[match.away.microname, match.away.shortname, match.away.name]}
                        fontStyles={'bold 16px "DinforPBR", sans-serif'}

                    />
                </div>));
                if(hasLiveMatches){
                    row.push((<div style={{minWidth: 24, maxWidth: 24}}></div>));
                }
            }
            children.push((<Divider  key={cc++} className={classes.divider}></Divider>));
            if(hasLiveMatches) {
                children.push((<div  key={cc++} style={{display: 'flex', paddingTop: 16, paddingBottom: 16}}>
                   <div style={{marginTop: 2}}> <PulsatingCircle /></div>
                    <Typography
                                 variant='body1'
                                 component='div'
                                 classes={{root: classes.p}}
                    >
                        Spiel läuft
                    </Typography>
                </div>));

            }

        } catch (e) {
            console.log(e);
        }
        const refreshClassName = reloading ? 'spinner-active' : '';

        return (
            <div className={classes.dpaSportCard}>
                <div style={{paddingBottom: 16}}/>
                <div className={classes.titleRow}>
                    <Typography
                        variant='h2'
                        component='h2'
                        classes={{root: classes.title_h3}}
                    >
                        BEGEGNUNGEN
                    </Typography>
                    <a
                        className={classes.linkContainer}
                        onClick={this.reload}
                    >
                        <div style={{paddingTop: 4}}>
                            <RefreshIcon className={refreshClassName} style={{fill: "#1D89BF", fontSize: 16}}/>
                        </div>
                        <Typography
                            variant='h3'
                            component='h3'
                            classes={{root: classes.linkText}}
                        >
                            aktualisieren
                        </Typography>
                    </a>
                </div>
                <div key={cc++} className={classes.row} style={{paddingBottom: 16}}>
                    <div key={cc++} className={classes.border} style={{
                        width: 36,
                        height: 36,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: 4,
                    }}>
                        <IconButton
                            className={classes.arrowButton}
                            onClick={() => {
                                this.onPrevDay()
                            }}
                        >
                            <NavigateBeforeIcon className={classes.arrow}/>
                            <InvisibleImg alt={"vorheriger Spieltag"}/>
                        </IconButton>
                    </div>
                    <div key={cc++} className={classes.border} style={{
                        flexGrow: 80, display: "flex",
                        justifyContent: "center",
                        marginLeft: 12,
                        marginRight: 12,
                    }}>
                        <FormControl>
                            <Select
                                SelectProps={{
                                    classes: {icon: classes.icon},
                                }}
                                disableUnderline={true}
                                className={classes.formControl}
                                value={selectedMatchDay}
                                onChange={this.onMatchDaySelected}
                                renderValue={(selected) => (<div>{selected.day}. Spieltag</div>)}
                            >
                                {this.getOptions()}
                            </Select>
                        </FormControl>
                    </div>
                    <div key={cc++} className={classes.border} style={{
                        width: 36,
                        height: 36,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: 4,
                    }}>

                        <IconButton
                            className={classes.arrowButton}
                            onClick={() => {
                                this.onNextDay()
                            }}
                        >
                            <NavigateNextIcon className={classes.arrow}/>
                            <InvisibleImg alt={"nächster Spieltag"}/>
                        </IconButton>
                    </div>
                </div>
                <div key={cc++}>{children}</div>
            </div>
        );
    }

     utcTimeToBerlin(date, utcTimeString) {

        const [hours, minutes] = utcTimeString.split(':').map(Number);
        const [day, month, year] = date.split(".").map(Number);

        const utcDate = new Date(Date.UTC(
            year,
            month - 1,
            day,
            hours,
            minutes
        ));

        return utcDate.toLocaleString('de-DE', {
            timeZone: 'Europe/Berlin',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false // 24-Stunden-Format erzwingen
        });

    }

    getOptions() {
        let options = [];
        const {matchDays} = this.state;
        for (let day of matchDays.days) {
            options.push((
                <MenuItem key={day.day} value={day}>
                    <Typography
                        variant='h2'
                        component='h2'
                        classes={{root: this.props.classes.caption}}
                    >
                        {""
                            + day.day
                            + ". Spieltag ("
                            + day.startDate
                            + " - "
                            + day.endDate
                            + ")"}
                    </Typography>
                </MenuItem>));
        }
        return options;
    }


    getMatchResult(match, teamId) {
        if (match.real_live_status === "upcoming" || match.real_live_status === "none") {
            return "";
        }

        for (var result of match.match_result) {
            if (result.team_id === teamId) {
                return result.match_result;
            }
        }
        return "";
    }

    getLogoUrl(id) {
        return config.api_base + config.dpa_logo_40_path + id;
    }

    load() {
        const {data, lastModified} = this.state;
        const {kachel} = this.props;
        let type = kachel.type;
        if (!data) {
            this.getViewData(type, kachel.current_season_id)
        } else {
            this.headViewData(type, kachel.current_season_id, lastModified);
        }
    }

    _reload() {
        const {kachel} = this.props;
        const {reloadingTimestamp} = this.state;
        if(reloadingTimestamp != null) return;
        let type = kachel.type;
        this.setState({reloadingTimestamp: Date.now()});
        this.getViewData(type, kachel.current_season_id)
    }

    _onDataReceived(data, lastModified) {
        let selectedMatchDay;
        let matchDays = new MatchDays();
        try {
            if (!this.isTable()) {
                let round = data[0].competition[0].season[0].round[0];

                for (let match of round.match) {
                    let day = matchDays.update(match.matchday, match.match_date);
                    if (day.day === round.current_matchday) {
                        selectedMatchDay = day;
                    }

                }
            }
            const {reloadingTimestamp} = this.state;
            const now = Date.now();
            if(reloadingTimestamp != null || now-reloadingTimestamp < 1000 ) {
                setTimeout(() => {
                    this.setState({
                        data: data,
                        lastModified: lastModified,
                        selectedMatchDay: selectedMatchDay,
                        matchDays: matchDays,
                        error: null,
                        reloadingTimestamp: null
                    });
                }, 1000 - (now-reloadingTimestamp));
            } else {
                this.setState({
                    data: data,
                    lastModified: lastModified,
                    selectedMatchDay: selectedMatchDay,
                    matchDays: matchDays,
                    error: null,
                    reloadingTimestamp: null
                });
            }
        } catch (e) {
            console.log(e);
            this.setState({
                data: null,
                lastModified: null,
                selectedMatchDay: null,
                matchDays: new MatchDays(),
                error: e,
                reloadingTimestamp: null
            })
        }
    }

    buildUrl(type, seasonId) {
        let url;
        if (type === "uestra/dpa-sportlive-table") {
            url = config.api_base + config.dpa_table_path + seasonId;
        } else if (type === "uestra/dpa-sportlive-matches") {
            url = config.api_base + config.dpa_matches_path + seasonId;
        } else {
            return
        }
        return url
    }

    async _getViewData(type, seasonId) {
        let url = this.buildUrl(type, seasonId);
        if (!url) return
        const response = await axios.get(url, {
            headers: {},
            withCredentials: false,
            transformResponse: [(data) => {
                return data
            }],
        });
        if (response && 200 === response.status && response.data) {
            const lastModified = response.headers['last-modified'];
            this.onDataReceived(JSON.parse(response.data), lastModified);
        } else {
            throw new Error('request failed', response);
        }
    }

    async _headViewData(type, seasonId, lastModified) {
        let url = this.buildUrl(type, seasonId);
        if (!url) return

        const response = await axios.head(url, {
            headers: {},
            withCredentials: false,
        });
        if (response && 200 === response.status) {
            const lastModifiedHeader = response.headers['last-modified'];
            if (lastModifiedHeader !== lastModified) {
                this.getViewData(type).catch((error) => {
                    //console.log(error)
                });
            }
        }
    }


    asP(text, color) {
        let style = color === null ? {} : {color: color};
        return <Typography variant='body1' component='p' classes={{root: this.props.classes.p}} style={style}>{text}</Typography>

    }

    asHeader(text, align = "end") {
        return <Typography variant='body1' component='p' style={{textAlign: align}}
                           classes={{root: this.props.classes.headerText}}>{text}</Typography>

    }

    formatMatchDate(matchDate) {
        let digits = matchDate.split(".");
        let year = parseInt(digits[2]);
        let month = parseInt(digits[1]);
        let day = parseInt(digits[0]);

        let date = new Date(year, month - 1, day);

        let options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        };
        return new Intl.DateTimeFormat("de-DE", options).format(date);
    }

    _onMatchDaySelected(event) {
        this.setState({
            selectedMatchDay: event.target.value,
        });


    }

    onNextDay() {
        const {selectedMatchDay, matchDays} = this.state;
        if (!matchDays.hasNext(selectedMatchDay)) return;
        this.setState({
            selectedMatchDay: matchDays.next(selectedMatchDay),
        });
    }

    onPrevDay() {
        const {selectedMatchDay, matchDays} = this.state;
        if (!matchDays.hasPrev(selectedMatchDay)) return;
        this.setState({
            selectedMatchDay: matchDays.prev(selectedMatchDay),
        });

    }
}

DpaSportsApiCard.propTypes = {
    kachel: PropTypes.object.isRequired,
    userLang: PropTypes.string,
    full: PropTypes.bool
};

export default function _DpaSportsApiCard(props) {
    const classes = useStyles();
    return <DpaSportsApiCard {...props} classes={classes}/>;
}

class MatchDay {
    constructor(day, startDate) {
        this.day = day;
        this.startDate = startDate;
        this.endDate = null;
    }

    toString() {
        return `${this.day}. Spieltag`;
    }
}

class MatchDays {
    constructor() {
        this.days = [];
    }

    get isEmpty() {
        return this.days.length === 0;
    }

    update(day, dateStr) {
        for (let d of this.days) {
            if (d.day === day) {
                d.endDate = dateStr;
                return d;
            }
        }
        const matchDay = new MatchDay(day, dateStr);
        this.days.push(matchDay);
        return matchDay;
    }

    hasNext(matchDay) {
        return this.next(matchDay) !== null;
    }

    next(matchDay) {
        let found = false;
        for (let d of this.days) {
            if (found) return d;
            if (d.day === matchDay.day) {
                found = true;
            }
        }
        return null;
    }

    hasPrev(matchDay) {
        return this.prev(matchDay) !== null;
    }

    prev(matchDay) {
        let last = null;
        for (let d of this.days) {
            if (d.day === matchDay.day) {
                return last;
            }
            last = d;
        }
        return null;
    }
}
